// extracted by mini-css-extract-plugin
export default {"wrapper":"WiringDiagramHighV_wrapper__1Vnqh","fullScreen_btn":"WiringDiagramHighV_fullScreen_btn__uSYmX"};